'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id) {
  return function (dispatch) {
    return dispatch(_defineProperty({
      feis_id: feis_id

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.dressChecksReportUrl)(feis_id)
      },
      types: ['GET_DRESS_CHECKS_REPORT_START', 'GET_DRESS_CHECKS_REPORT', 'GET_DRESS_CHECKS_REPORT_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/dress-checks/getDressChecksReport.js
// module id = 624
// module chunks = 0